
import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class PedidosYaFetchAPI {

    //Function to update a store status on PedidosYa
    static async updateStoreStatus(branchoffice_id, token) {
        const res = await server(`/pedidosya/store`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: {
                branchoffice_id: branchoffice_id
            }
        });
        return res
    }

    //Function to get a store status on PedidosYa
    static async getStoreStatus(branchoffice_id, token) {
        const res = await server(`/pedidosya/store?branchoffice_id=${branchoffice_id}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res
    }

}

